export default `float i,g,e,s=4.,l;
    vec3 q=p;
    for(int j=0;j++<9;)
      p=mod(p-1.,2.)-1.,
      l=1.2/dot(p,p),
      p*=l, s*=l;
    return abs(p.y)/s;
  }`